<template>
<div class="block-edit-shop-wrap">
  <el-tabs v-model="activeName" @tab-click="handleClick">
    <el-tab-pane label="门店详情" name="first">
      <shop-details></shop-details>
    </el-tab-pane>
  </el-tabs>
</div>
</template>

<script>
import shopDetails from './components/shop-details.vue'
export default {
  components: {
    shopDetails
  },
  data () {
    return {
      activeName: 'first'
    }
  }
}
</script>

<style lang="scss" scoped>
.block-edit-shop-wrap {
  margin:0 0 0 20px;
}
</style>
